<template>
  <div class="Privacy-block">
    <div class="divider">
      <div class="container">
        <img src="../assets/icon-divider.svg" alt="" />
      </div>
    </div>
    <section class="privacy">
      <div class="container">
        <div class="privacy-content">
          <div class="privacy-title">
            Privacy Statement & Disclaimer - Data-driven Creative (DDC) ROI Calculator Tool
          </div>
          <div class="privacy-text">
            This Policy applies between you, the user of this Data-driven Creative (DDC) ROI
            Calculator Tool and FiveStones (the owner and provider of this tool and website).
          </div>
          <div class="privacy-text">
            For the purpose of this Data-driven Creative (DDC) ROI Calculator Tool, we require you
            to enter details about your creative specifications and requirements. FiveStones may use
            the data collected via the Data-driven Creative (DDC) ROI Calculator Tool form to
            improve the experience of the tool itself and for marketing purposes, by submitting
            details within the Data-driven Creative (DDC) ROI Calculator Tool, you acknowledge and
            give permission for FiveStones to utilise this information.
          </div>
          <hr />
          <div class="privacy-text">
            For further details, please visit our website privacy policy or contact our team at
            info@fivestones.net
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Privacy',
  data() {
    return {}
  }
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/Privacy.vue